import { InvoiceForm } from '@features/invoices/types/invoiceForm/invoiceForm'
import { InvoiceSummary } from '@features/invoices/types/invoices/invoiceSummary'
import { TaxSummary } from '@features/invoices/types/taxSummary'
import { getInvoiceSummaryTotals } from '@features/invoices/utils/getInvoiceSummaryTotals'
import { hasInvoiceLineDiscount } from '@features/invoices/utils/hasInvoiceLineDiscount'

import { NumberValue } from '../../../../../utils'

// Reuse creation-flow totals so non-row lines, including subtotals, are excluded.
export const getUpdatedQuoteSummary = (formData: InvoiceForm, currentSummary: InvoiceSummary): InvoiceSummary => {
  const exchangeRate = formData.exchangeRate ?? currentSummary.exchangeRate
  const hasLineDiscount = hasInvoiceLineDiscount(formData.invoiceLines)
  const { discountTotal, grossTotal, netTotal, subTotal, taxSummary, taxTotal } = getInvoiceSummaryTotals({
    currency: formData.currency,
    discountType: formData.discountType,
    globalDiscount: !hasLineDiscount && formData.discount > 0 ? formData.discount : undefined,
    invoiceLines: formData.invoiceLines,
  })

  // Exchange rate expresses foreign currency per unit of local currency.
  const toLocal = (foreignAmount: number): number =>
    exchangeRate ? new NumberValue(foreignAmount).divide(exchangeRate).getRounded() : foreignAmount

  const foreignTaxSummary: TaxSummary[] = taxSummary.map(({ amount, percentage }) => ({
    amount,
    percentage: percentage ?? 0,
  }))
  const localTaxSummary: TaxSummary[] = foreignTaxSummary.map(({ amount, percentage }) => ({
    amount: toLocal(amount),
    percentage,
  }))

  return {
    ...currentSummary,
    exchangeRate,
    foreignCurrency: formData.currency || currentSummary.foreignCurrency,
    foreignDiscountTotal: discountTotal,
    foreignGrossTotal: grossTotal,
    foreignNetTotal: netTotal,
    foreignSubTotal: subTotal,
    foreignTaxSummary,
    foreignTaxTotal: taxTotal,
    localDiscountTotal: toLocal(discountTotal),
    localGrossTotal: toLocal(grossTotal),
    localNetTotal: toLocal(netTotal),
    localSubTotal: toLocal(subTotal),
    localTaxSummary,
    localTaxTotal: toLocal(taxTotal),
  }
}
